/* eslint-disable(prettier/prettier) */
// 🔴 DO NOT EDIT — This file is generated.

import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
const ChevronLeftSvg = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path d="m8.712 10 3.394 3.394q.172.173.177.435a.6.6 0 0 1-.177.443.6.6 0 0 1-.44.181.6.6 0 0 1-.438-.18l-3.745-3.746A.7.7 0 0 1 7.27 10q0-.15.048-.28a.7.7 0 0 1 .165-.247l3.745-3.745a.6.6 0 0 1 .435-.177.6.6 0 0 1 .443.177q.18.18.181.439 0 .258-.181.439z" />
  </svg>
)
const ForwardRef = forwardRef(ChevronLeftSvg)
export default ForwardRef
